export enum PromoCodeType {
	ABSOLUTE = 'absolute',
	RELATIVE = 'relative',
	DELIVERY_FEE = 'delivery_fee',
	BOGO = 'bogo',
	REWARD = 'reward',
	FREE_ARTICLE = 'free_article',
	COUPON = 'coupon',
	ABSOLUTE_ARTICLE = 'absolute_article',
	RELATIVE_ARTICLE = 'relative_article',
	SINGLE_RELATIVE_ARTICLE = 'single_relative_article',
	GIFT_CARD = 'gift_card',
	VOID = 'void',
	PLUS_ONE = 'plus_one_free',
}
